import { cx } from './util.js';

export interface LinearProgressProps {
  label: string;
  /** 0 to 100. Leave out for an indeterminate bar. */
  value?: number;
  className?: string;
}

/** A wavy progress bar on the native `progress` element, so it keeps its semantics. */
export function LinearProgress({ label, value, className }: LinearProgressProps) {
  return (
    <progress
      className={cx('k-progress', className)}
      aria-label={label}
      {...(value === undefined ? {} : { value, max: 100 })}
    />
  );
}
